module.exports = __webpack_public_path__ + "static/media/bia-logo-son.4277e58d.png";